import React, { useState, useRef, useEffect  } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import SingleEvent from 'models/Event';
import {
  convertDateStringToMomentObj,
  formatEventStartDate,
  formatEventEndDate,
} from 'utils/dateTimeUtils';
import '../../../styles/ScheduleContainer/EditEventInfoModal.scss';
import { Col, DatePicker, Row, Form, Button, Select } from 'antd';
import Icon from '@ant-design/icons';
import DropdownIcon from 'shared/components/Icon/icons/DownArrow';
import { CalendarOutlined } from '@ant-design/icons';
//import Tooltip from 'shared/components/Tooltip';
import { urlTransform, urlValidation } from 'utils/formHelpers';
import Input from 'shared/components/Input';
import TextBox from 'shared/components/TextBox';
import { connect } from 'react-redux';
import Container from 'shared/components/Container';
import timezoneOptions from 'shared/constants/timezones';
import editEventGeneralInfo from 'features/EventContainer/redux/actions/scheduleActions/editEventInfo';
import { CURRENT_EVENT_SEASON } from 'shared/constants/eventConstants';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

// const { Option } = Dropdown;
const { RangePicker } = DatePicker;

const FormItem = Form.Item;

const rowProps = {
  type: 'flex',
  gutter: 20,
  className: 'm-t-20',
};

const EditMeetingModalContent = (props) => {
  const {
    eventDetails,
    editEventInfo,
    savingEvent,
    closeCb,
  } = props;
  const { t } = useTranslation();

  const [form] = Form.useForm();
  const { included, time_zone } = eventDetails;

  const eventPage = new SingleEvent(eventDetails, included);
  const programName = eventPage.getProgramName();
  const eventName = eventPage.name;
  const eventUrl = eventPage.url;
  const regionName = eventPage.getRegionName();
  const countryName = eventPage.getCountryName();
  const eventDescription = eventPage.description;
  const { eventCode, eventId } = eventPage;
  const[hasValue, setHasValue] = useState(false);
  const [rangeDates, setRangeDates] = useState({
    start: eventPage.startDate,
    end: eventPage.endDate,
  });

   useEffect(() => {
    if (eventPage.startDate && eventPage.endDate) {
      setHasValue(true);
    }
  }, []);

  const handleDateConfirm = (value) => {
    if (Array.isArray(value) &&
      value.length === 2 &&
      value[0] &&
      value[1]
    ) {
      setHasValue(true);
    }
    else {
      setHasValue(false);
    }
      
};

  const saveEvent = async (e) => {
    if (e && 'preventDefault' in e) e.preventDefault();
    form.validateFields().then(async (values, err) => {
      const { dates } = values;
      const startDate = Array.isArray(dates) ? dates[0].format('YYYY-MM-DD') : undefined;
      const endDate = Array.isArray(dates) ? dates[1].format('YYYY-MM-DD') : undefined;

       const initialStartDate= rangeDates.start;
       const initialEndDate= rangeDates.end;

       const isDateChanged=initialStartDate!=startDate || initialEndDate!=endDate;

      const payload = {
        title: values.title,
        url: urlTransform(values.url),
        description: values.description,
        start_date: startDate,
        end_date: endDate,
        timezone: values.timezone,
        season: CURRENT_EVENT_SEASON,
      };

      await editEventInfo(payload,isDateChanged, eventId, closeCb);
    });
  };

  const onFinishFailed = ({ errorFields }) => {
    form.scrollToField(errorFields[0].name);
  };

   const options = timezoneOptions.map(tz => ({
    value: tz.id,
    label: tz.description
  }));


  return (
    <div>
      <Container type="default">
        <div className="c-edit-event-info__title">
          <h1 className="heading--charcoal h--bold h-2">{t('editGeneralEventInfoLabel')}</h1>
          {/* <Tooltip /> */}
        </div>
      </Container>

      <Container type="medium">
        <Form
          hideRequiredMark
          onFinish={saveEvent}
          onFinishFailed={onFinishFailed}
          name="EditMeeting"
          form={form}
          initialValues={{
            title: eventName,
            program: programName,
            timezone: time_zone,
            region: regionName,
            country: countryName,
            code: eventCode,
            url: eventUrl,
            description: eventDescription,
          }}
        >
          <Row {...rowProps}>
            <Col xs={24} md={12}>
              <FormItem
                name="title"
                label={<span>{t('eventLabel')}</span>}
                rules={[{ required: true, message: t('enterEventTitleLabel') }]}
              >
                <Input size="large" placeholder={t('eventLabel')} />
              </FormItem>
            </Col>
            <Col xs={24} md={12}>
              <FormItem name="program" label={<span>{t('programLabel')}</span>}>
                <Input disabled size="large" />
              </FormItem>
            </Col>
          </Row>
          <Row {...rowProps}>
            <Col id="edit-event-range" style={{ position: 'relative' }} xs={24} md={10}>
              <FormItem
                 name='dates'
                 label={<span>{t('dateLabel')}</span>}
                 initialValue={[dayjs(rangeDates.start, 'YYYY-MM-DD'), dayjs(rangeDates.end, 'YYYY-MM-DD')]}
                  >
                    <RangePicker
                     placeholder={[t('startDateLabel'), t('endDateLabel')]}
                     className="schedule-session-modal__range-picker"
                      size="large"
                      getCalendarContainer={() => document.getElementById('edit-meeting-range-picker')}
                      onChange={handleDateConfirm}
                     
                    />
              </FormItem>
            </Col>
            <Col xs={0} md={1}></Col>
            <Col xs={24} md={13}>
              <FormItem
                name="timezone"
                label={<span>Time zone</span>}
                rules={[{ required: true, message: '' }]}
              >              
                <Select placeholder="Select Time Zone" options={options} suffixIcon={<Icon component={DropdownIcon} style={{color: '#0066B3', pointerEvents: 'none'}} />}/>

              </FormItem>
            </Col>
          </Row>
          <Row {...rowProps}>
            <Col xs={24} md={8}>
              <FormItem name="region" label={t('regionLabel')}>
                <Input disabled size="large" />
              </FormItem>
            </Col>
          </Row>
          <Row {...rowProps}>
            <Col xs={24} md={8}>
              <FormItem name="country" label={t('countryLabel')}>
                <Input disabled size="large" />
              </FormItem>
            </Col>
          </Row>
          <Row {...rowProps}>
            <Col xs={24} md={8}>
              <FormItem name="code" label={<span>Code</span>}>
                <Input disabled size="large" />
              </FormItem>
            </Col>
          </Row>
          <Row {...rowProps}>
            <Col xs={24} md={16}>
              <FormItem
                name="url"
                label={<span>{t('eventUrlLabel')}</span>}
                rules={[urlValidation]}
              >
                <Input size="large" placeholder={t('eventUrlLabel')} />
              </FormItem>
            </Col>
          </Row>
          <Row {...rowProps}>
            <Col xs={24} md={16}>
              <FormItem name="description" label={<span>{t('descriptionLabel')}</span>}>
                <TextBox size="large" placeholder={t('descriptionLabel')} rows={5} />
              </FormItem>
            </Col>
          </Row>
          <Row {...rowProps} justify="end">
            <Button loading={savingEvent} disabled={!hasValue} htmlType="submit">
              {t('saveLabel')}
            </Button>
          </Row>
        </Form>
      </Container>
    </div>
  );
};

EditMeetingModalContent.propTypes = {
  form: PropTypes.object.isRequired,
  eventDetails: PropTypes.object.isRequired,
  editEventInfo: PropTypes.func.isRequired,
  savingEvent: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  const {
    event: { eventDetails, eventSchedule },
  } = state;
  const { isEditingEventGeneralInfo } = eventSchedule;
  return {
    eventDetails,
    savingEvent: isEditingEventGeneralInfo,
  };
};

export default connect(mapStateToProps, { editEventInfo: editEventGeneralInfo })(
  EditMeetingModalContent
);
